// extracted by mini-css-extract-plugin
export var text = "body-text-module--text--RsvjD";